import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
	startNotificationsSocket,
	stopNotificationsSocket,
} from "../utilities/notificationsSocket"

// L'éligibilité aux flux temps réel est dérivée des groupes via le registre
// des catégories : voir src/config/notificationCategories.js (miroir front de
// backend/svp/notifications.py). L'abonnement lui-même est fait côté serveur
// à la connexion (consumers.NotificationConsumer).

// Monté une fois à la racine (App). Ouvre la WS dès que l'utilisateur est connecté :
// tout user authentifié est abonné à son groupe perso (notifs ciblées, ex. prise de
// main d'une fiche) ; les flux par groupe (signalement…) restent filtrés côté back.
export const useNotificationsSocket = () => {
	const dispatch = useDispatch()
	const { token } = useSelector((state) => state.navInfo.login)
	const allowed = !!token

	useEffect(() => {
		if (!allowed) return
		startNotificationsSocket(token, dispatch)
		return () => stopNotificationsSocket()
	}, [allowed, token, dispatch])
}
